import { ApiBase } from "../../core/api-base";

export interface SocialHandleCheckResponse {
    success?: 0 | 1;
    message?: string;
    data?: {
        exists?: boolean;
        method?: "http" | "format";
        checked_url?: string | null;
    };
}

export class UserSocialHandleCheckApi extends ApiBase {
    public static check(platform: string, value: string): Promise<Response> {
        return this.apiPost(
            "/api/v1/users/social-handle-check",
            { platform, value },
            { noSpinner: true },
        );
    }
}
